import type { GetPreviewLinkResponse } from "@/types/preview";
import axios from "axios";
import { getLinkPreview as linkPreviewLib } from "link-preview-js";

class PreviewService {
	private readonly fallbackApi =
		"https://favorited-link-preview.herokuapp.com/api/link-preview";

	/**
	 * Fallback: Use link-preview-js directly in frontend
	 */
	private async getLinkPreviewFromLib(url: string) {
		return await linkPreviewLib(url);
	}

	/**
	 * Primary: Use backend API for preview (to avoid CORS and enrich metadata)
	 */
	private async getLinkPreviewFromAPI(url: string) {
		const apiUrl = new URL(this.fallbackApi);
		apiUrl.searchParams.set("url", url);

		const { data } = await axios.get<GetPreviewLinkResponse>(apiUrl.toString());
		return data;
	}

	/**
	 * Attempts to fetch preview from API first, falls back to link-preview-js on failure
	 */
	async getLinkInformation(url: string) {
		try {
			return await this.getLinkPreviewFromLib(url);
		} catch {
			return await this.getLinkPreviewFromAPI(url);
		}
	}
}

export const previewService = Object.freeze(new PreviewService());
